<template>
  <main class="main cus_deal_list" role="main" v-if="isCompleted">
    <div class="main_con sl_main_con" id="main_con">
      <div class="img_title" v-if="dl == 'ocb'">
        <img
          :src="require(`@/assets/front/images/v2/deal/img_ocb_ttl.png`)"
          alt=""
        />
      </div>
      <div class="img_title" v-else-if="dl == 'hanapay'">
        <img
          :src="require(`@/assets/front/images/v2/deal/img_hanapay_ttl.png`)"
          alt=""
        />
      </div>
      <div class="img_title" v-else>
        <img
          :src="require(`@/assets/front/images/v2/deal/img_perce_ttl.png`)"
          alt=""
        />
      </div>

      <div class="srch_wrap">
        <div class="input_txt input_srch">
          <input
            type="search"
            placeholder="휴대폰 기종 검색"
            v-model.trim="keyword"
            @keypress.enter="fnSearch"
          />
          <button class="btn_srch" @click.stop="fnSearch"></button>
        </div>
      </div>

      <div class="filter_area">
        <div class="pro_filter">
          <div class="filter_inner" ref="filter_inner">
            <div class="btn_refresh_cover">
              <button class="btn_refresh" @click="funcRefresh">
                <img
                  :src="
                    require('@/assets/front/images/v2/arrows/ar_refresh.svg')
                  "
                  alt="새로고침"
                />
              </button>
            </div>
            <div class="btn_select_cover">
              <button
                class="btn_select"
                id="telecomFilterBtn"
                @click="
                  showFilter(
                    'selTelecomFilter',
                    'telecomFilterBtn',
                    'telecomFilter',
                  )
                "
              >
                {{ telecomFilterTitle }}
              </button>
              <button
                class="btn_select"
                id="joinFilterBtn"
                @click="
                  showFilter('selJoinFilter', 'joinFilterBtn', 'joinFilter')
                "
              >
                {{ joinFilterTitle }}
              </button>
              <button
                class="btn_select"
                id="saleFilterBtn"
                @click="
                  showFilter('selSaleFilter', 'saleFilterBtn', 'saleFilter')
                "
              >
                {{ saleFilterTitle }}
              </button>
              <button
                class="btn_select"
                id="buyFilterBtn"
                @click="showFilter('selBuyFilter', 'buyFilterBtn', 'buyFilter')"
              >
                {{ buyFilterTitle }}
              </button>
            </div>
          </div>
        </div>
        <div class="filter_cont" id="telecomFilter">
          <!--클릭시 on-->
          <h5 class="filter_cont_ttl">통신사</h5>
          <ul>
            <li v-for="(item, index) in telecomFilterTypes" :key="index">
              <div class="checkbox_r">
                <input
                  type="checkbox"
                  :id="item.id"
                  :name="item.id"
                  :value="item.value"
                  v-model="selectTelecom"
                  @click="funSelectTelecom(item.label, item.value)"
                />
                <label :for="item.id">{{ item.label }}</label>
              </div>
            </li>
          </ul>
        </div>
        <div class="filter_cont" id="joinFilter">
          <!--클릭시 on-->
          <h5 class="filter_cont_ttl">가입유형</h5>
          <ul>
            <li v-for="(item, index) in joinFilterTypes" :key="index">
              <div class="checkbox_r">
                <input
                  type="checkbox"
                  :id="item.id"
                  :name="item.id"
                  :value="item.value"
                  v-model="selectJoin"
                  @click="funSelectJoin(item.label, item.value)"
                />
                <label :for="item.id">{{ item.label }}</label>
              </div>
            </li>
          </ul>
        </div>
        <div class="filter_cont" id="saleFilter">
          <!--클릭시 on-->
          <h5 class="filter_cont_ttl">할인방법</h5>
          <ul>
            <li v-for="(item, index) in saleFilterTypes" :key="index">
              <div class="checkbox_r">
                <input
                  type="checkbox"
                  :id="item.id"
                  :name="item.id"
                  :value="item.value"
                  v-model="selectSale"
                  @click="funSelectSale(item.label, item.value)"
                />
                <label :for="item.id">{{ item.label }}</label>
              </div>
            </li>
          </ul>
        </div>
        <div class="filter_cont" id="buyFilter">
          <!--클릭시 on-->
          <h5 class="filter_cont_ttl">구매방식</h5>
          <ul>
            <li v-for="(item, index) in buyFilterTypes" :key="index">
              <div class="checkbox_r">
                <input
                  type="checkbox"
                  :id="item.id"
                  :name="item.id"
                  :value="item.value"
                  v-model="selectBuy"
                  @click="funSelectBuy(item.label, item.value)"
                />
                <label :for="item.id">{{ item.label }}</label>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="sec_total_sort" v-if="totalCnt != 100000">
        <div class="total">총 {{ totalCnt }}개</div>
        <div class="sort">
          <button @click="openSortModal">
            {{ selectedSortLabel }}
          </button>
        </div>
      </div>

      <div class="sec_con_list">
        <ul v-if="totalCnt > 0">
          <li class="list_item" v-for="(item, index) in list" :key="index">
            <EstimateList
              :item="item"
              :storeInfo="item.dealStore"
              :mode="`DEAL`"
              @moreReview="moreReview"
              @goShopDetail="goShopDetail"
              @goDetailView="goDetailView"
              @enterChatRoom="enterChatRoom"
              @goDeviceDetail="goDeviceDetail"
            />
          </li>
        </ul>
        <ul v-else-if="totalCnt == 0">
          <li>
            <div class="no_reasult">
              <img
                :src="
                  require('@/assets/front/images/v2/character/img_empty_result.png')
                "
              />

              <p>조건에 맞는 견적이 없습니다.<br />검색을 다시 해 주세요!</p>
            </div>
          </li>
        </ul>
        <infinite-loading
          ref="infiniteLoading"
          :direction="direction"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <span slot="no-more"></span>
          <span slot="no-results"></span>
          <span slot="spinner"></span>
        </infinite-loading>
      </div>
    </div>
    <DealListSortModal :show="isSortModal" @close="closeSortModal" />
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import EstimateList from '@/front/customer/views/mobile/components/EstimateList';
import DealListSortModal from '@/front/customer/views/mobile/modal/DealListSortModal';

import InfiniteLoading from 'vue-infinite-loading';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

export default {
  components: {
    DealListSortModal,
    EstimateList,
    InfiniteLoading,
  },
  data() {
    return {
      isCompleted: false,
      telecomFilterTitle: '통신사',
      telecomFilterTypes: [
        { id: 'telecom_all', label: '전체', value: 'ALL' },
        { id: 'telecom_01', label: 'SKT', value: 'SKT' },
        { id: 'telecom_02', label: 'KT', value: 'KT' },
        { id: 'telecom_03', label: 'LGU+', value: 'LGUPLUS' },
        { id: 'telecom_04', label: 'SK7 모바일', value: '7MOBILE' },
        { id: 'telecom_05', label: 'KT M모바일', value: 'MMOBILE' },
        { id: 'telecom_06', label: 'U+ 모바일', value: 'UPLUSE' },
        { id: 'telecom_07', label: 'LG헬로비전(KT망)', value: 'HELLOKT' },
        { id: 'telecom_08', label: 'LG헬로비전(LG망)', value: 'HELLOUPLUS' },
      ],
      selectTelecom: ['ALL'],
      selectTelecomLabel: ['통신사'],

      joinFilterTitle: '가입유형',
      joinFilterTypes: [
        { id: 'join_all', label: '전체', value: 'ALL' },
        { id: 'join_01', label: '기기변경', value: 'CHANGE' },
        { id: 'join_02', label: '번호이동', value: 'MNP' },
        { id: 'join_03', label: '신규가입', value: 'NEW' },
      ],
      selectJoin: ['ALL'],
      selectJoinLabel: ['가입유형'],

      saleFilterTitle: '할인방법',
      saleFilterTypes: [
        { id: 'sale_all', label: '전체', value: 'ALL' },
        { id: 'sale_01', label: '단말할인(공시지원금)', value: 'SUPPORT' },
        { id: 'sale_02', label: '요금할인(선택약정)', value: 'PLAN' },
      ],
      selectSale: ['ALL'],
      selectSaleLabel: ['할인방법'],

      buyFilterTitle: '구매방식',
      buyFilterTypes: [
        { id: 'buy_all', label: '전체', value: 'ALL' },
        { id: 'buy_01', label: '매장방문', value: 'VISIT' },
        { id: 'buy_02', label: '비대면', value: 'ONLINE' },
      ],
      selectBuy: ['ALL'],
      selectBuyLabel: ['구매방식'],

      selectedSortLabel: '최신 순',
      selectedSortValue: 'CREATED_AT_DESC',

      isSortModal: false,

      keyword: '',

      mobileDealList: [],
      list: [],
      page: 1,
      size: 10,
      direction: 'top',
      infiniteId: 0,
      visitPage: 0, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      isVisitName: ['Mobile.DealDetail'], // 뒤로 이동시 가능한 방문 페이지 정리
      totalCnt: 100000,
      dl: 'perce', // ocb, perce, hanapay
      dealCd: '',
      createRoom: '',
    };
  },
  async created() {
    this.dl = this.$route.query.dl;

    if (this.dl == 'ocb') {
      this.dealCd = 'OCB_2503';
    } else if (this.dl == 'perce') {
      this.dealCd = 'PERCE_2503';
    } else if (this.dl == 'hanapay') {
      this.dealCd = 'HANAPAY_2503';
    } else {
      this.dl = 'perce';
      this.dealCd = 'PERCE_2503';
    }

    this.$nextTick(() => {
      this.isCompleted = true;
    });
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  watch: {},
  async mounted() {
    this.infiniteId += 1; //리스트 가져오기.
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  updated() {},
  computed: {
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
    }),
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_DEAL,
      mobileTypes.MOBILE_DEAL_CHAT,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
    ]),
    showFilter(sel, btnId, conId) {
      // alert(2);
      if (sel != this.selectFilter) {
        this.setFilterView();
      }
      var someElement1 = document.getElementById(btnId);
      someElement1.classList.toggle('on');

      var someElement2 = document.getElementById(conId);
      someElement2.classList.toggle('on');

      this.selectFilter = sel;
    },
    setFilterView() {
      // if (this.promotionCode == 'KT2408') {
      //   return;
      // }
      // alert(1);
      var btnDetailElement = document.querySelector('.btn_select.on');

      if (btnDetailElement != null) {
        btnDetailElement.classList.remove('on');
      }

      var moreInfoElement = document.querySelector('.filter_cont.on');

      if (moreInfoElement != null) {
        moreInfoElement.classList.remove('on');
      }
    },
    funSelectTelecom(label, val) {
      // this.isFilterSelect = true;
      const findTelecom = this.selectTelecom.findIndex(
        element => element == val,
      );

      const findTelecomLabel = this.selectTelecomLabel.findIndex(
        element => element == label,
      );

      console.log('findTelecom = {}', findTelecom);

      // 선택한 값이 없을 경우
      if (findTelecom === -1) {
        // ALL일 경우
        if (val == this.telecomFilterTypes[0].value) {
          this.selectTelecom.splice(0); // 초기화
          this.selectTelecomLabel.splice(0);
        } else {
          const findAllTelecom = this.selectTelecom.findIndex(
            element => element == this.telecomFilterTypes[0].value,
          );

          if (findAllTelecom >= 0) {
            this.selectTelecom.splice(findAllTelecom, 1);
          }

          const findAllTelecomLabel = this.selectTelecomLabel.findIndex(
            element => element == this.telecomFilterTypes[0].label,
          );

          if (findAllTelecomLabel >= 0) {
            this.selectTelecomLabel.splice(findAllTelecomLabel, 1);
          }
        }

        this.selectTelecom.push(val);
        if (val == 'ALL') {
          this.selectTelecomLabel.push('통신사');
        } else {
          if (this.selectTelecomLabel[0] == '통신사') {
            this.selectTelecomLabel.splice(0);
          }
          this.selectTelecomLabel.push(label);
        }
      } else {
        // 선택한 값이 있을 경우
        this.selectTelecom.splice(findTelecom, 1);
        this.selectTelecomLabel.splice(findTelecomLabel, 1);
      }

      // alert(this.selectTelecom.length);

      if (this.selectTelecom.length === 0) {
        this.$nextTick(() => {
          this.selectTelecom.push('ALL');
          this.telecomFilterTitle = '통신사';
          this.getListPageOne();
        });
      } else {
        this.telecomFilterTitle = this.selectTelecomLabel.join(',');
        this.getListPageOne();
      }
      console.log(
        'this.selectTelecomthis.selectTelecomthis.selectTelecomthis.selectTelecom',
      );

      console.log(this.selectTelecom);
    },
    funSelectJoin(label, val) {
      // this.isFilterSelect = true;
      const findJoin = this.selectJoin.findIndex(element => element == val);

      const findJoinLabel = this.selectJoinLabel.findIndex(
        element => element == label,
      );

      console.log('findJoin = {}', findJoin);

      // 선택한 값이 없을 경우
      if (findJoin === -1) {
        // ALL일 경우
        if (val == this.joinFilterTypes[0].value) {
          this.selectJoin.splice(0); // 초기화
          this.selectJoinLabel.splice(0);
        } else {
          const findAllJoin = this.selectJoin.findIndex(
            element => element == this.joinFilterTypes[0].value,
          );

          if (findAllJoin >= 0) {
            this.selectJoin.splice(findAllJoin, 1);
          }

          const findAllJoinLabel = this.selectJoinLabel.findIndex(
            element => element == this.joinFilterTypes[0].label,
          );

          if (findAllJoinLabel >= 0) {
            this.selectJoinLabel.splice(findAllJoinLabel, 1);
          }
        }

        this.selectJoin.push(val);
        if (val == 'ALL') {
          this.selectJoinLabel.push('가입유형');
        } else {
          if (this.selectJoinLabel[0] == '가입유형') {
            this.selectJoinLabel.splice(0);
          }
          this.selectJoinLabel.push(label);
        }
      } else {
        // 선택한 값이 있을 경우
        this.selectJoin.splice(findJoin, 1);
        this.selectJoinLabel.splice(findJoinLabel, 1);
      }

      if (this.selectJoin.length === 0) {
        this.$nextTick(() => {
          this.selectJoin.push('ALL');
          this.joinFilterTitle = '가입유형';
          this.getListPageOne();
        });
      } else {
        this.joinFilterTitle = this.selectJoinLabel.join(',');
        this.getListPageOne();
      }
      console.log(
        'this.selectJointhis.selectJointhis.selectJointhis.selectJoin',
      );

      console.log(this.selectJoin);
    },
    funSelectSale(label, val) {
      // this.isFilterSelect = true;
      const findSale = this.selectSale.findIndex(element => element == val);

      const findSaleLabel = this.selectSaleLabel.findIndex(
        element => element == label,
      );

      console.log('findSale = {}', findSale);

      // 선택한 값이 없을 경우
      if (findSale === -1) {
        // ALL일 경우
        if (val == this.saleFilterTypes[0].value) {
          this.selectSale.splice(0); // 초기화
          this.selectSaleLabel.splice(0);
        } else {
          const findAllSale = this.selectSale.findIndex(
            element => element == this.saleFilterTypes[0].value,
          );

          if (findAllSale >= 0) {
            this.selectSale.splice(findAllSale, 1);
          }

          const findAllSaleLabel = this.selectSaleLabel.findIndex(
            element => element == this.saleFilterTypes[0].label,
          );

          if (findAllSaleLabel >= 0) {
            this.selectSaleLabel.splice(findAllSaleLabel, 1);
          }
        }

        this.selectSale.push(val);
        if (val == 'ALL') {
          this.selectSaleLabel.push('할인방법');
        } else {
          if (this.selectSaleLabel[0] == '할인방법') {
            this.selectSaleLabel.splice(0);
          }
          this.selectSaleLabel.push(label);
        }
      } else {
        // 선택한 값이 있을 경우
        this.selectSale.splice(findSale, 1);
        this.selectSaleLabel.splice(findSaleLabel, 1);
      }

      if (this.selectSale.length === 0) {
        this.$nextTick(() => {
          this.selectSale.push('ALL');
          this.saleFilterTitle = '할인방법';
          this.getListPageOne();
        });
      } else {
        this.saleFilterTitle = this.selectSaleLabel.join(',');
        this.getListPageOne();
      }
      console.log(
        'this.selectSalethis.selectSalethis.selectSalethis.selectSale',
      );

      console.log(this.selectSale);
    },
    funSelectBuy(label, val) {
      // this.isFilterSelect = true;
      const findBuy = this.selectBuy.findIndex(element => element == val);

      const findBuyLabel = this.selectBuyLabel.findIndex(
        element => element == label,
      );

      console.log('findBuy = {}', findBuy);

      // 선택한 값이 없을 경우
      if (findBuy === -1) {
        // ALL일 경우
        if (val == this.buyFilterTypes[0].value) {
          this.selectBuy.splice(0); // 초기화
          this.selectBuyLabel.splice(0);
        } else {
          const findAllBuy = this.selectBuy.findIndex(
            element => element == this.buyFilterTypes[0].value,
          );

          if (findAllBuy >= 0) {
            this.selectBuy.splice(findAllBuy, 1);
          }

          const findAllBuyLabel = this.selectBuyLabel.findIndex(
            element => element == this.buyFilterTypes[0].label,
          );

          if (findAllBuyLabel >= 0) {
            this.selectBuyLabel.splice(findAllBuyLabel, 1);
          }
        }

        this.selectBuy.push(val);
        if (val == 'ALL') {
          this.selectBuyLabel.push('구매방식');
        } else {
          if (this.selectBuyLabel[0] == '구매방식') {
            this.selectBuyLabel.splice(0);
          }
          this.selectBuyLabel.push(label);
        }
      } else {
        // 선택한 값이 있을 경우
        this.selectBuy.splice(findBuy, 1);
        this.selectBuyLabel.splice(findBuyLabel, 1);
      }

      if (this.selectBuy.length === 0) {
        this.$nextTick(() => {
          this.selectBuy.push('ALL');
          this.buyFilterTitle = '구매방식';
          this.getListPageOne();
        });
      } else {
        this.buyFilterTitle = this.selectBuyLabel.join(',');
        this.getListPageOne();
      }
      console.log('this.selectBuythis.selectBuy');

      console.log(this.selectBuy);
    },
    async funcRefresh() {
      this.telecomFilterTitle = '통신사';
      this.selectTelecom = ['ALL'];
      this.selectTelecomLabel = ['통신사'];

      this.joinFilterTitle = '가입유형';
      this.selectJoin = ['ALL'];
      this.selectJoinLabel = ['가입유형'];

      this.saleFilterTitle = '할인방법';
      this.selectSale = ['ALL'];
      this.selectSaleLabel = ['할인방법'];

      this.buyFilterTitle = '구매방식';
      this.selectBuy = ['ALL'];
      this.selectBuyLabel = ['구매방식'];

      this.setFilterView();

      this.keyword = '';
      this.selectedSortLabel = '최신 순';
      this.selectedSortValue = 'CREATED_AT_DESC';

      this.$refs.filter_inner.scrollLeft = 0;
      await this.getListPageOne();
    },
    openSortModal() {
      this.isSortModal = true;
    },
    async closeSortModal(dataType, label, val) {
      if (dataType) {
        this.selectedSortLabel = label;
        this.selectedSortValue = val;
        // this.params.orderType = val.value;
        // this.getList();
      }
      this.isSortModal = false;
      await this.getListPageOne();
    },
    async getDealList() {
      const params = {
        page: this.page,
        size: this.size,
        telecoms: this.selectTelecom[0] == 'ALL' ? '' : this.selectTelecom,
        joinTypes: this.selectJoin[0] == 'ALL' ? '' : this.selectJoin,
        payTypes: this.selectSale[0] == 'ALL' ? '' : this.selectSale,
        openTypes: this.selectBuy[0] == 'ALL' ? '' : this.selectBuy,
        orderType: this.selectedSortValue,
        keyword: this.keyword.trim(),
        dealCd: this.dealCd,
      };

      console.log('paramsparamsparams');
      console.log(params);

      this.mobileDealList = await this[mobileTypes.SELECT_MOBILE_DEAL](params);
      console.log('this.mobileDealList');
      console.log(this.mobileDealList);

      this.totalCnt = this.mobileDealList.pagination.totalElements;
    },
    async fnSearch() {
      await this.getListPageOne();
    },
    moreReview(storeId) {
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: storeId },
        query: { type: 'mobile' },
      });
    },
    goShopDetail(storeId) {
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: storeId,
        },
      });
    },
    goDetailView(id) {
      this.$router.push({
        name: 'Mobile.DealDetail',
        query: {
          id: id,
          dl: this.dl,
        },
      });
    },
    async enterChatRoom(id, storeId) {
      // 로그인 체크
      const isAuth = await util.isAuth();
      if (isAuth) {
        await this.chatroomCreateCheck(storeId);
        const params = {
          id: id,
        };

        this[mobileTypes.MOBILE_DEAL_CHAT](params)
          .then(res => {
            console.log('resresresresresresres');
            console.log(res);

            this.$router.push({
              name: 'chat.room',
              params: {
                uuid: res,
                createRoom: this.createRoom,
              },
            });
          })
          .catch(e => {
            console.log('error');
          });
      } else {
        console.log('비로그인');

        this.$router.push({
          name: 'Auth.Login',
          query: {
            dl_id: this.$route.query.dl + '_' + id,
          },
        });
      }
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_mobile_deal_from_detail',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;

          // 데이터 담고 삭제
          await localStorage.removeItem('visit_mobile_deal_from_detail');
        }
      }
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#main_con');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getDealList();

        if (this.page == 1) {
          this.list = [];
        }

        if (this.mobileDealList.content.length) {
          this.list.push(...this.mobileDealList.content);

          console.log('this.list');
          console.log(this.list);

          // 페이지 이동시 저장된 페이지 개수만큼 호출
          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          this.page += 1;
          $state.loaded();
        } else {
          // 페이지 다 호출하면 저장된 위치로 이동
          $state.complete();
        }
      }
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
      this.list = [];
    },
    goDeviceDetail(deviceId, id) {
      this.$router.push({
        name: 'Mobile.DeviceInfo',
        query: {
          deviceId: deviceId,
          id: id,
          dl: this.dl,
        },
      });
    },
    async chatroomCreateCheck(storeId) {
      await this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      }).then(() => {
        if (this.chatroom_with.count == 0) {
          this.createRoom = 'Y';
        }
      });
    },
  },
};
</script>
